<template>
  <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen flex flex-col">
    <!-- 🌟 HEADER -->
    <!-- HEADER -->
    <header class="bg-[#1a1a1a] text-white shadow sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <!-- LOGO -->
        <div class="flex items-center gap-2">
          <img src="/brand/getlance-logo.svg" alt="Logo" class="h-20 w-auto" />
        </div>

        <!-- NAV DESKTOP -->
        <nav class="hidden md:flex items-center gap-8">
          <a href="#sobre" class="hover:text-[#b99a52] transition">Sobre</a>
          <a href="#categorias" class="hover:text-[#b99a52] transition">Categorias</a>
          <a href="#seguranca" class="hover:text-[#b99a52] transition">Segurança</a>
          <a href="#como-funciona" class="hover:text-[#b99a52] transition">Como funciona</a>
        </nav>

        <!-- AÇÕES DESKTOP -->
        <div class="hidden md:flex items-center gap-3">
          <template v-if="!isAuthenticated">
            <router-link to="/login"
              class="px-4 py-2 rounded-full border border-white/20 bg-white/10 hover:bg-white/20 transition whitespace-nowrap">
              Fazer login
            </router-link>
            <router-link to="/cadastro"
              class="px-4 py-2 rounded-full bg-[#b99a52] hover:bg-[#a18446] text-white transition whitespace-nowrap">
              Cadastrar
            </router-link>
          </template>
          <div v-else class="relative" ref="avatarWrapRef">
            <button type="button"
              class="w-10 h-10 rounded-full bg-[#374151] hover:bg-[#4b5563] text-white font-semibold text-lg flex items-center justify-center transition focus:outline-none focus:ring-2 focus:ring-white/50 border border-white/20"
              :title="userName"
              @click="showDropdown = !showDropdown"
              aria-haspopup="true"
              :aria-expanded="showDropdown">
              {{ avatarLetter }}
            </button>
            <div v-if="showDropdown"
              class="absolute right-0 mt-2 w-52 py-2 bg-white rounded-xl shadow-lg border border-gray-200 text-[#1f2937] z-50">
              <div class="px-4 py-2 border-b border-gray-100">
                <p class="text-sm font-medium text-[#152a34] truncate" :title="userName">{{ userName }}</p>
              </div>
              <router-link to="/perfil" @click="showDropdown = false"
                class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                Meu Perfil
              </router-link>
              <router-link to="/meus-projetos" @click="showDropdown = false"
                class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                Meus Projetos
              </router-link>
              <router-link to="/meus-agendamentos" @click="showDropdown = false"
                class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                Meus Agendamentos
              </router-link>
              <div class="border-t border-gray-100 my-1"></div>
              <button type="button"
                class="w-full text-left px-4 py-2.5 text-sm hover:bg-red-50 hover:text-red-700 transition"
                @click="logout">
                Sair
              </button>
            </div>
          </div>
        </div>

        <!-- MENU MOBILE -->
        <button class="md:hidden text-2xl leading-none" @click="showMenu = true" aria-label="Abrir menu">
          ☰
        </button>
      </div>

      <!-- DRAWER MOBILE -->
      <div v-if="showMenu" class="fixed inset-0 bg-black/40 backdrop-blur-sm z-[999] flex md:hidden"
        @click.self="showMenu = false">
        <div class="w-80 max-w-[85vw] bg-white text-[#152a34] h-full p-6 overflow-y-auto shadow-xl animate-slideLeft">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold">Menu</h2>
            <button class="text-gray-500 text-xl" @click="showMenu = false" aria-label="Fechar menu">✕</button>
          </div>

          <!-- LINKS -->
          <nav class="space-y-2">
            <a href="#sobre" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#sobre')">Sobre</a>
            <a href="#categorias" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#categorias')">Categorias</a>
            <a href="#seguranca" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#seguranca')">Segurança</a>
            <a href="#como-funciona" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#como-funciona')">Como funciona</a>
          </nav>

          <div class="my-6 border-t"></div>

          <!-- CTAs -->
          <div class="space-y-3">
            <template v-if="!isAuthenticated">
              <router-link to="/login"
                class="block w-full text-center px-4 py-3 rounded-xl border border-[#e0dcd6] bg-white hover:bg-gray-50 transition font-semibold"
                @click="showMenu = false">
                Fazer login
              </router-link>

              <router-link to="/cadastro"
                class="block w-full text-center px-4 py-3 rounded-xl bg-[#b99a52] hover:bg-[#a18446] text-white transition font-semibold"
                @click="showMenu = false">
                Cadastrar
              </router-link>
            </template>
            <template v-else>
              <router-link to="/perfil"
                class="block w-full text-center px-4 py-3 rounded-xl border border-[#e0dcd6] bg-white hover:bg-gray-50 transition font-semibold"
                @click="showMenu = false">
                Meu Perfil
              </router-link>
              <router-link to="/meus-projetos"
                class="block w-full text-center px-4 py-3 rounded-xl border border-[#e0dcd6] bg-white hover:bg-gray-50 transition font-semibold"
                @click="showMenu = false">
                Meus Projetos
              </router-link>
              <button
                class="block w-full text-center px-4 py-3 rounded-xl bg-red-50 border border-red-200 hover:bg-red-100 text-red-700 transition font-semibold"
                @click="logout">
                Sair
              </button>
            </template>
          </div>
        </div>

        <div class="flex-1"></div>
      </div>
    </header>

    <!-- 🟡 HERO -->
    <section class="relative flex-1 flex flex-col justify-center items-center text-center bg-cover bg-center">
      <div class="absolute inset-0 bg-black/60"></div>

      <div class="relative z-10 max-w-5xl px-6 mt-15">
        <h1 class="text-4xl sm:text-5xl font-extrabold text-white mb-4">
          Freelancers remotos e <span class="text-[#b99a52]">prestadores presenciais</span> para empresas e pessoas
        </h1>
        <p class="text-white/90 text-lg mb-8">
          Publique seu projeto, encontre profissionais qualificados e contrate com segurança em um marketplace completo.
        </p>
        <div class="bg-white/10 backdrop-blur-sm border border-white/25 rounded-2xl p-5 sm:p-6 text-left mb-8">
          <p class="text-white font-semibold text-lg mb-4 text-center">Escolha por onde você quer começar</p>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div class="bg-white rounded-xl p-5 h-full flex flex-col">
              <span class="inline-flex text-xs font-semibold uppercase tracking-wide bg-[#152a34]/10 text-[#152a34] px-2.5 py-1 rounded-full mb-3">
                Mercado Remoto
              </span>
              <h3 class="text-[#152a34] text-xl font-bold mb-2">Publicar projeto e encontrar trabalho online</h3>
              <p class="text-gray-600 text-sm mb-4">
                Para quem quer divulgar demandas remotas, receber propostas e para freelancers que buscam novos projetos.
              </p>
              <router-link to="/projetos"
                class="inline-flex justify-center w-full px-4 py-2.5 rounded-full bg-[#b99a52] hover:bg-[#a18446] text-white font-semibold transition mt-auto">
                Ir para Projetos Remotos
              </router-link>
            </div>
            <div class="bg-white rounded-xl p-5 h-full flex flex-col">
              <span class="inline-flex text-xs font-semibold uppercase tracking-wide bg-[#152a34]/10 text-[#152a34] px-2.5 py-1 rounded-full mb-3">
                Serviços Presenciais
              </span>
              <h3 class="text-[#152a34] text-xl font-bold mb-2">Encontrar profissionais para atuação presencial</h3>
              <p class="text-gray-600 text-sm mb-4">
                Para contratar prestadores locais para serviços no local, como manutenção, reformas, beleza e mais.
              </p>
              <router-link to="/buscar-prestadores"
                class="inline-flex justify-center w-full px-4 py-2.5 rounded-full border border-[#d6d3ce] bg-white hover:bg-gray-100 text-[#152a34] font-semibold transition mt-auto">
                Ir para Serviços Presenciais
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 💼 SEÇÃO SOBRE -->
    <section id="sobre" class="py-20 bg-[#fff] text-center px-6">
      <h2 class="text-3xl font-bold mb-4 text-[#152a34]">Trabalhar nunca foi tão fácil</h2>
      <p class="text-gray-600 max-w-3xl mx-auto mb-10">
        O GetLance é um marketplace moderno que conecta quem precisa de um serviço a quem sabe fazer.
        Aqui você cria propostas, negocia valores com segurança e garante pagamentos com garantia GetLance.
      </p>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-5xl mx-auto">
        <!-- Card 1 -->
        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <div class="h-12 w-12 mx-auto mb-4 rounded-xl bg-white/70 flex items-center justify-center shadow-sm"
            aria-hidden="true">
            <!-- inline SVG (briefcase) -->
            <svg viewBox="0 0 24 24" class="h-7 w-7 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10 6a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v2H10V6Z" />
              <path d="M4 9h16a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z" />
              <path d="M8 12v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1" />
            </svg>
          </div>
          <h3 class="text-lg font-semibold mb-2">Crie sua proposta</h3>
          <p class="text-gray-500 text-sm">Publique o que precisa e receba ofertas de profissionais em minutos.</p>
        </div>

        <!-- Card 2 -->
        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <div class="h-12 w-12 mx-auto mb-4 rounded-xl bg-white/70 flex items-center justify-center shadow-sm"
            aria-hidden="true">
            <!-- inline SVG (chat) -->
            <svg viewBox="0 0 24 24" class="h-7 w-7 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-5a8 8 0 0 1-1-6 9 9 0 0 1 18 0Z" />
              <path d="M8 12h.01M12 12h.01M16 12h.01" stroke-linecap="round" />
            </svg>
          </div>
          <h3 class="text-lg font-semibold mb-2">Negocie com segurança</h3>
          <p class="text-gray-500 text-sm">Converse diretamente no chat da plataforma antes de fechar o negócio.</p>
        </div>

        <!-- Card 3 -->
        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <div class="h-12 w-12 mx-auto mb-4 rounded-xl bg-white/70 flex items-center justify-center shadow-sm"
            aria-hidden="true">
            <!-- inline SVG (shield/coin) -->
            <svg viewBox="0 0 24 24" class="h-7 w-7 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2l8 4v6c0 5-3.5 9.5-8 10-4.5-.5-8-5-8-10V6l8-4Z" />
              <path d="M9 12h6M10 9h4M10 15h4" stroke-linecap="round" />
            </svg>
          </div>
          <h3 class="text-lg font-semibold mb-2">Pagamento com garantia GetLance</h3>
          <p class="text-gray-500 text-sm">
            O valor fica reservado e é liberado somente após o serviço ser entregue com sucesso.
          </p>
        </div>
      </div>
    </section>

    <!-- 🧭 CATEGORIAS -->
    <section id="categorias" class="bg-[#152a34] text-white py-20 text-center px-6">
      <h2 class="text-3xl font-bold mb-4">Encontre profissionais por categoria</h2>
      <p class="text-white/80 mb-10">Temos centenas de categorias para todo tipo de projeto.</p>

      <div class="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto">
        <span v-for="cat in mockCategories" :key="cat"
          class="px-5 py-2 bg-white/10 rounded-full text-sm hover:bg-[#b99a52] hover:text-white cursor-pointer transition">
          {{ cat }}
        </span>
      </div>
    </section>

    <!-- 🔒 SEGURANÇA -->
    <section id="seguranca" class="py-20 bg-[#f6f4f1] text-center px-6">
      <h2 class="text-3xl font-bold mb-6 text-[#152a34]">Garantia financeira GetLance</h2>
      <p class="text-gray-600 max-w-3xl mx-auto mb-8">
        A GetLance oferece um sistema de garantia que assegura que o prestador receba apenas após o serviço ser
        concluído e aprovado. Transparência e confiança de ponta a ponta.
      </p>
    </section>

    <!-- 🗣️ DEPOIMENTOS (AUMENTADOS) -->
    <section class="bg-[#fff] py-20 text-center px-6">
      <h2 class="text-3xl sm:text-4xl font-bold mb-12 text-[#152a34]">Histórias de sucesso</h2>

      <!-- mais largo + mais espaçamento -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
        <div v-for="(testimony, i) in testimonials" :key="i"
          class="bg-[#f6f4f1] rounded-2xl shadow p-8 hover:shadow-xl transition flex flex-col justify-between text-left">
          <!-- quote icon -->
          <div class="flex items-start justify-between gap-4 mb-6">
            <div class="flex items-center gap-2">
              <span class="inline-flex h-10 w-10 rounded-xl bg-white/70 items-center justify-center shadow-sm"
                aria-hidden="true">
                <svg viewBox="0 0 24 24" class="h-6 w-6 text-[#b99a52]" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <path d="M10 11H6a4 4 0 0 0 0 8h2v-6h2v-2Zm8 0h-4a4 4 0 0 0 0 8h2v-6h2v-2Z" />
                </svg>
              </span>
              <p class="text-sm font-semibold text-[#152a34]">Depoimento</p>
            </div>

            <!-- stars -->
            <div class="flex gap-1" aria-label="Avaliação 5 estrelas">
              <svg v-for="s in 5" :key="s" viewBox="0 0 24 24" class="h-4 w-4 text-[#b99a52]" fill="currentColor">
                <path
                  d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27Z" />
              </svg>
            </div>
          </div>

          <!-- texto maior -->
          <p class="text-gray-700 text-base leading-relaxed mb-8 italic">
            “{{ testimony.text }}”
          </p>

          <div class="flex items-center gap-4 pt-6 border-t border-black/5">
            <!-- avatar inline (sem imagem) -->
            <div class="h-12 w-12 rounded-full bg-white/80 shadow-sm flex items-center justify-center"
              aria-hidden="true">
              <svg viewBox="0 0 24 24" class="h-7 w-7 text-[#152a34]" fill="none" stroke="currentColor"
                stroke-width="2">
                <path d="M20 21a8 8 0 0 0-16 0" />
                <path d="M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z" />
              </svg>
            </div>

            <div>
              <p class="font-semibold text-lg text-[#152a34] leading-tight">{{ testimony.name }}</p>
              <p class="text-sm text-gray-500">{{ testimony.role }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ⚙️ COMO FUNCIONA -->
    <section id="como-funciona" class="bg-white py-20 text-center px-6">
      <h2 class="text-3xl font-bold mb-10 text-[#152a34]">Como funciona?</h2>
      <div class="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8">
        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4">
            1
          </div>
          <h3 class="font-semibold text-lg mb-2">Crie sua conta</h3>
          <p class="text-gray-500 text-sm">Leva menos de um minuto para começar a usar a plataforma.</p>
        </div>

        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4">
            2
          </div>
          <h3 class="font-semibold text-lg mb-2">Publique ou procure um trabalho</h3>
          <p class="text-gray-500 text-sm">Crie um anúncio ou busque projetos de acordo com suas habilidades.</p>
        </div>

        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4">
            3
          </div>
          <h3 class="font-semibold text-lg mb-2">Finalize e receba</h3>
          <p class="text-gray-500 text-sm">Conclua o trabalho, receba o pagamento e construa sua reputação.</p>
        </div>
      </div>
    </section>

    <!-- 🚀 CTA FINAL -->
    <section class="bg-[#b99a52] text-white text-center py-16">
      <h2 class="text-3xl font-bold mb-3">Pronto para começar?</h2>
      <p class="mb-6">Crie sua conta gratuita e comece a trabalhar hoje mesmo.</p>
      <router-link to="/cadastro"
        class="bg-white text-[#152a34] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition">
        Criar minha conta
      </router-link>
    </section>

    <AppFooter />
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import AppFooter from "@/components/AppFooter.vue";

const router = useRouter();
const showMenu = ref(false);
const showDropdown = ref(false);
const avatarWrapRef = ref(null);

const currentUserData = ref(null);

function loadCurrentUserData() {
  try {
    currentUserData.value = JSON.parse(localStorage.getItem("userData") || "null");
  } catch {
    currentUserData.value = null;
  }
}

const isAuthenticated = computed(() => {
  const token = currentUserData.value?.token || currentUserData.value?.access_token || currentUserData.value?.user?.token;
  return !!token;
});

const userName = computed(() => {
  return currentUserData.value?.user?.name || "Usuário";
});

const avatarLetter = computed(() => {
  const first = userName.value.trim().charAt(0);
  return (first || "U").toUpperCase();
});

function onDocumentClick(e) {
  if (avatarWrapRef.value && !avatarWrapRef.value.contains(e.target)) {
    showDropdown.value = false;
  }
}

function logout() {
  localStorage.removeItem("userData");
  currentUserData.value = null;
  showDropdown.value = false;
  showMenu.value = false;
  router.push("/");
}

function closeAndScroll(hash) {
  showMenu.value = false;

  setTimeout(() => {
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.location.hash = hash;
  }, 50);
}

onMounted(() => {
  loadCurrentUserData();
  document.addEventListener("click", onDocumentClick);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick);
});

const mockCategories = [
  "Reformas e Construção",
  "Design Gráfico",
  "Programação",
  "Serviços Domésticos",
  "Beleza e Estética",
  "Manutenção e Reparos",
  "Transporte e Fretes",
  "Eventos e Festas",
  "Consultoria",
];

const testimonials = [
  {
    name: "Lucas Almeida",
    role: "Designer Freelancer",
    text: "Consegui meus primeiros clientes em menos de uma semana usando o GetLance!",
    avatar: "/avatar-1.jpg",
  },
  {
    name: "Mariana Souza",
    role: "Empresária",
    text: "Contratar profissionais se tornou muito mais fácil e seguro. A plataforma é incrível!",
    avatar: "/avatar-2.jpg",
  },
  {
    name: "Carlos Mendes",
    role: "UX Design",
    text: "Recebo projetos e o pagamento sempre cai direitinho. Recomendo demais!",
    avatar: "/avatar-3.jpg",
  },
];
</script>